export type ImageRuntimeEnv = 'dev' | 'stg' | 'prd';

/**
 * Porting checklist config:
 * update these values when copying the image components to another project.
 */
export const IMAGE_PROJECT_CONFIG = {
  imageKit: {
    defaultTransforms: ['q-75'] as const,
  },
  resourceHints: {
    productionAssetOrigin: 'https://assets.isuzu-tis.com',
    rootAssetHintEnvs: ['prd', 'stg'] as const,
    getRuntimeEnv: (): ImageRuntimeEnv => {
      const env = process.env.NEXT_PUBLIC_ENV;
      if (env === 'prd' || env === 'stg' || env === 'dev') return env;
      return 'dev';
    },
  },
} as const;
